{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Pohjat",
    "DESCRIPTION": "Tarkastele WhatsApp-saapuneet-kansioistasi synkronoituja viestipohjia. Luo tai muokkaa pohjaa palveluntarjoajasi kautta.",
    "COUNT": "{n} pohja | {n} pohjaa",
    "LEARN_MORE": "Lue lisää WhatsApp-pohjista",
    "SYNC_TEMPLATES": "Synkronoi pohjat",
    "SYNC_SUCCESS": "Pohjien synkronointi käynnistyi kaikille WhatsApp-saapuneet-kansioille. Muutosten näkyminen voi kestää muutaman minuutin.",
    "PARTIAL_SYNC_ERROR": "Pohjien synkronointi käynnistyi vain joillekin WhatsApp-saapuneet-kansioille, muita ei voitu synkronoida.",
    "SYNC_ERROR": "Pohjien synkronointia ei voitu käynnistää. Yritä uudelleen.",
    "SEARCH_PLACEHOLDER": "Hae sisällön tai nimen mukaan...",
    "MANAGE_IN_META": "Hallitse Metassa",
    "LOADING": "Ladataan WhatsApp-pohjia...",
    "EMPTY": "WhatsApp-pohjia ei löytynyt.",
    "NO_RESULTS": "Suodattimia vastaavia pohjia ei löytynyt.",
    "FETCH_ERROR": "WhatsApp-pohjia ei voitu ladata. Yritä uudelleen.",
    "PARTIAL_FETCH_ERROR": "Joitakin WhatsApp-pohjia ei voitu ladata. Yritä uudelleen.",
    "LAST_SYNC_ATTEMPT": "Viimeisin synkronointiyritys {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Ei lähetetty WhatsApp-hyväksyntään"
    },
    "FILTERS": {
      "ALL_INBOXES": "Kaikki saapuneet-kansiot",
      "ALL_LANGUAGES": "Kaikki kielet",
      "ALL_TYPES": "Kaikki tyypit"
    },
    "TYPES": {
      "TEXT": "Teksti",
      "IMAGE": "Kuva",
      "VIDEO": "Video",
      "DOCUMENT": "Asiakirja",
      "CALL_TO_ACTION": "Toimintakehotus",
      "COPY_CODE": "Kopioi koodi"
    },
    "PREVIEW": {
      "TITLE": "Pohjan esikatselu",
      "DESCRIPTION": "Esikatsele, miltä pohja näyttää WhatsAppissa.",
      "OPEN": "Esikatsele {name}",
      "CLOSE": "Sulje esikatselu",
      "DETAILS": "Pohjan tiedot",
      "STATUS": "Tila",
      "TYPE": "Sisältötyyppi",
      "CATEGORY": "Kategoria",
      "LANGUAGE": "Kieli",
      "INBOXES": "Saapuneet-kansiot"
    }
  }
}
